import { Navigate, useParams } from 'react-router-dom'

/** /card-details/:cardId (legacy portal) -> /cards/:cardId */
export function LegacyCardRedirect() {
  const { cardId } = useParams()
  return <Navigate to={`/cards/${cardId}`} replace />
}

/** /customer/:userId/profile and /user/:userId/profile (legacy portal) -> the new detail pages */
export function LegacyProfileRedirect({ kind }: { kind: 'customer' | 'team' }) {
  const { userId } = useParams()
  return <Navigate to={`/${kind === 'customer' ? 'customers' : 'team'}/${userId}`} replace />
}
